import { useState, useEffect } from "react";


// JuChain 测试网络配置
const JUCHAIN_TESTNET = {
  chainId: '0x31767', // BSC测试网 chainId 97 的十六进制
  chainName: 'JuChain Testnet',
  nativeCurrency: { // 本地货币信息（可选）
    name: 'Ju Coin', // 货币名称
    symbol: 'JU', // 货币符号
    decimals: 18, // 货币小数位数
  },
  rpcUrls: [
    'https://testnet-rpc.juchain.org'
  ],
  blockExplorerUrls: ['https://testnet.juscan.io/']
}

//JuChain 正式网络配置
const JUCHAIN_MAINNET = {
  chainId: '0x33450', // 
  chainName: 'JuChain Mainnet', // 链名称
  nativeCurrency: { // 本地货币信息（可选）
      name: 'Ju Coin', // 货币名称
      symbol: 'JU', // 货币符号
      decimals: 18, // 货币小数位数
  },
  rpcUrls: ['https://rpc.juchain.org'], // RPC URL（可选）
  blockExplorerUrls: ['https://explorer.juscan.io/'] // 区块浏览器 URL（可选）
};
const JuList = [JUCHAIN_MAINNET,JUCHAIN_TESTNET]


export function useWeb3() {
  const [providers, setProviders] = useState([]);
  const [walletAddress, setWalletAddress] = useState(localStorage.getItem('address') || null);
  const [chanIndex, setChanIndex] = useState(localStorage.getItem('chanIndex') || 0);
  let JUCHAIN_PARAMS = JuList[chanIndex || 0] || JUCHAIN_MAINNET;


  useEffect(() => {
    const handleProviderAnnounce = (event) => {
      const detail = event.detail;
      if (detail && detail.info) {
        setProviders((prevProviders) => {
          if (!prevProviders.some((p) => p.info.uuid === detail.info.uuid)) {
            return [...prevProviders, detail];
          }
          return prevProviders;
        });
      }
    };

    window.addEventListener("eip6963:announceProvider", handleProviderAnnounce);
    window.dispatchEvent(new Event("eip6963:requestProvider"));

    return () => {
      window.removeEventListener("eip6963:announceProvider", handleProviderAnnounce);
    };
  }, []);

  useEffect(() => {
    console.log(chanIndex,'chanIndex改变');
    if(walletAddress){
      JUCHAIN_PARAMS = JuList[chanIndex || 0] || JUCHAIN_MAINNET;
      switchToJuChain()
    }
  }, [chanIndex]);

  const connect = async (type) => {
    let providerDetail = providers.find((p) => {
      const name = p?.info?.name?.toLowerCase() || "";
      return (
        (type === "metamask" && name.includes("metamask")) ||
        (type === "okx" && name.includes("okx")) ||
        (type === "trust" && name.includes("trust")) ||
        (type === "bitkeep" && name.includes("bitget")) ||
        (type === "tokenpocket" && name.includes("tokenpocket")) ||
        (type === "coin98" && name.includes("coin98")) ||
        (type === "gate" && name.includes("gate"))
      );
    });

    let provider = providerDetail?.provider || window.ethereum;

    if (!provider) {
      console.error(`❌ 没有找到类型为 ${type} 的钱包，并且未检测到默认钱包`);
      return;
    }

    try {
      const accounts = await provider.request({ method: "eth_requestAccounts" });

      if (accounts && accounts.length > 0) {
        setWalletAddress(accounts[0]);
      }

      const currentChainId = await provider.request({ method: "eth_chainId" });

      if (currentChainId.toLowerCase() !== JUCHAIN_PARAMS.chainId.toLowerCase()) {
        try {
          await provider.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: JUCHAIN_PARAMS.chainId }],
          });
          console.log("✅ 切换到 JUChain 成功!");
        } catch (switchError) {
          if (switchError.code === 4902) {
            try {
              await provider.request({
                method: "wallet_addEthereumChain",
                params: [JUCHAIN_PARAMS],
              });
              console.log("✅ 已成功添加 JUChain!");
            } catch (addError) {
              console.error("❌ 添加链失败: ", addError);
            }
          } else {
            console.error("❌ 切换链失败: ", switchError);
          }
        }
      } else {
        console.log("✅ 已经连接到 JUChain!");
      }
      return accounts[0];
    } catch (error) {
      console.error(`❌ 连接失败:`, error);
    }
  };

  const switchIndex = (index)=>{
    setChanIndex(index)
    localStorage.setItem('chanIndex',index)
    if(!walletAddress) connect()
  }

  // 切换到JuChain测试网
  const switchToJuChain = async () => {
    let provider = providers?.provider || window.ethereum;
    try {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: JUCHAIN_PARAMS.chainId }]
      })
      return true
    } catch (switchError) {
      // 如果网络不存在，添加网络
      if (switchError.code === 4902) {
        try {
          await provider.request({
            method: 'wallet_addEthereumChain',
            params: [JUCHAIN_PARAMS]
          })
          return true
        } catch (addError) {
          console.error('添加网络失败:', addError)
          return false
        }
      }
      console.error('切换网络失败:', switchError)
      return false
    }
  }

  return { connect, providers, walletAddress, switchIndex};
}
